@if(resizeManager.isPortrait){
  <ion-header [ngStyle]="{'position': isWeb ? 'relative' : 'fixed'}">
    <ion-toolbar>
      <ion-buttons slot="start">
        <ion-back-button (click)="back()" text=""></ion-back-button>
      </ion-buttons>
      <ion-title>{{filename}}</ion-title>
      <ion-buttons slot="end">
        @if (!isWeb) {
          <ion-button style="box-shadow: none" (click)="share()">
            <ion-icon name="fa-share"></ion-icon>
          </ion-button>
        }
        @if (isWeb) {
          <ion-button style="box-shadow: none" title="Herunterladen" (click)="download()">
            <ion-icon name="fa-arrow-down"></ion-icon>
          </ion-button>
        }
      </ion-buttons>
    </ion-toolbar>
  </ion-header>
}

<ion-content>
  <app-breadcrump-header [customOptions]="customBreadcrumbOptions"></app-breadcrump-header>
  <div class="view-container">
    @if(filename.endsWith(".heic") && !isApple){
      <div class="heic-info">
        <p style="color: var(--text);">HEIC-Dateien können nur im Safari-Browser oder auf einem iOS-Gerät angezeigt werden.</p>
        <div class="c-bttn" (click)="download()">
          Herunterladen
        </div>
      </div>
      }@else {
      <pinch-zoom id="pinch-zoom" style="height: 100%;" [autoHeight]="true" overflow="visible" backgroundColor="var(--background)" disableZoomControl="disable" [transition-duration]="400" overflow="visible" [minScale]="1" [limitPan]="true">
        <img [src]="convertedPath"/>
      </pinch-zoom>
    }
  </div>
</ion-content>
